import { Observable } from 'rxjs';
import { IApiResponse } from 'src/app/core/interfaces/api/api-response.interface';
import { IForgotPassword } from 'src/app/core/interfaces/login/forgotpassword.interface';
import { IVerifyPhoneNumber } from 'src/app/core/interfaces/login/verifyphonenumber.interface';
import { ILogin } from '../../../interfaces/login/login.interface';
import { IPhoneNumber } from '../../../interfaces/login/setphonenumber.interface';
import { IVerificationUser } from '../../../interfaces/login/verification.interface';

export abstract class AbstractLoginService {
  abstract userlogin(login: ILogin): Promise<any>;
  abstract verification(verification: IVerificationUser): Observable<any>;
  abstract getUserEmailAndPhone(): Observable<any>;
  abstract sendEmailCode(email: string): Promise<any>;
  abstract verifyEmailCode(code: string): Promise<any>;
  abstract reSendEmailCode(): Promise<any>;
  abstract sendPhoneCode(email: string): Promise<any>;
  abstract verifyPhoneCode(code: string): Promise<any>;
  abstract reSendPhoneCode(): Promise<any>;
  abstract autoLogin(login: ILogin): Observable<any>;
  abstract forgotPassword(forgotPassword: IForgotPassword): Promise<any>;
  abstract signInWithIntuit(): Observable<any>;
  abstract logout(): Observable<IApiResponse>;
  abstract rememberMe(rememberMe: boolean): Observable<any>;
  abstract sendUserPhoneCode(phoneNumber: IPhoneNumber): Observable<any>;
  abstract verifyUserPhoneNumber(
    confirmPhone: IVerifyPhoneNumber
  ): Observable<any>;
}
